// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1vcbfxw0 {
  background-color: var(--_18w76bw2b);
}
._1vcbfxw2 {
  background-color: var(--_18w76bw2e);
  border-color: var(--_18w76bw2e);
}
._1vcbfxw3 {
  background-color: var(--_18w76bw2x);
  border-color: var(--_18w76bw2x);
}
._1vcbfxw4 {
  min-width: 60px;
  font-size: var(--_18w76bw3m);
  border-bottom-width: 3px;
  border-bottom-style: solid;
  border-color: var(--_18w76bw2b);
}
._1vcbfxw5 {
  min-width: 80px;
  font-size: var(--_18w76bw3n);
  border-width: 1px;
  border-style: solid;
}
._1vcbfxw6 {
  min-width: 100px;
  font-size: var(--_18w76bw3o);
  border-width: 1px;
  border-style: solid;
}
._1vcbfxw7 {
  border-width: 0;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,4BAA4B;EAC5B,wBAAwB;EACxB,0BAA0B;EAC1B,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,4BAA4B;EAC5B,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB","sourcesContent":["._1vcbfxw0 {\n  background-color: var(--_18w76bw2b);\n}\n._1vcbfxw2 {\n  background-color: var(--_18w76bw2e);\n  border-color: var(--_18w76bw2e);\n}\n._1vcbfxw3 {\n  background-color: var(--_18w76bw2x);\n  border-color: var(--_18w76bw2x);\n}\n._1vcbfxw4 {\n  min-width: 60px;\n  font-size: var(--_18w76bw3m);\n  border-bottom-width: 3px;\n  border-bottom-style: solid;\n  border-color: var(--_18w76bw2b);\n}\n._1vcbfxw5 {\n  min-width: 80px;\n  font-size: var(--_18w76bw3n);\n  border-width: 1px;\n  border-style: solid;\n}\n._1vcbfxw6 {\n  min-width: 100px;\n  font-size: var(--_18w76bw3o);\n  border-width: 1px;\n  border-style: solid;\n}\n._1vcbfxw7 {\n  border-width: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
